import React from "react";
import { BillingService } from "@services/BillingService";
import { useFetch } from "@hooks/useFetch";
import { DataTable, LoadError } from "@components";
import { InvoiceTableColumns } from "./components/InvoiceTableColumns";
import { InvoiceTableExpandContent } from "./components/InvoiceTableExpandContent";
import { NextUpcomingInvoiceWidget } from "./components/NextUpcomingInvoiceWidget";


/**
 * Billing Page
 * ------------
 * This page displays the next upcoming payment and previous payment for the distributor.
 */

export const BillingPage: React.FC = () => {
  
  const billingService = new BillingService();
  const {
    data: invoices,
    isLoading: isLoadingInvoices,
    error: invoicesError,
    refetch: refetchInvoices,
  } = useFetch(
    billingService.getInvoices,
    [],
    []
  );

  // Built unconditionally: the column factory calls a store hook, so it can't sit behind the
  // error branch below without changing the hook count between renders.
  const invoiceColumns = InvoiceTableColumns();

  const nextUpcomingInvoice = invoices && invoices.length > 0 ? invoices[0] : undefined;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Billing</h1>
      </div>

      {/* A failed request must not read as "no invoices yet" */}
      {invoicesError && !isLoadingInvoices ? (
        <LoadError what="your invoices" onRetry={refetchInvoices} />
      ) : (
      <>
      <div className="mb-6">
        <NextUpcomingInvoiceWidget
          invoice={nextUpcomingInvoice}
          isLoading={isLoadingInvoices}
        />
      </div>

      <DataTable
        columns={invoiceColumns}
        data={(invoices || []).slice(1)} 
        isLoading={isLoadingInvoices}
        enableExpansion={true}
        expandableRowRenderer={(invoice) => (
          <InvoiceTableExpandContent invoice={invoice} />
        )}
        getRowCanExpand={() => true}
        title="Previous Invoices"
        description="Click on a row to view monthly breakdown"
      />
      </>
      )}
    </div>
  );
};

